import { getOrderSelectLabel } from '../utils/tiktokOrderDisplay'

const OrderSelect = ({ ordersList, currentOrderID, handleOrderChange, mobHide, isTiktok }) => {
  return (
    <div className="d-flex align-items-center">
        {/* <h1 className={`main-heading text-blue ${mobHide ? 'mob-hide' : ''}`}>
            Order {ordersList.length < 1 ? `#${currentOrderID}` : ''}
        </h1> */}
        {ordersList.length && (
            <div 
                className="select-box mb-sm-x2 mb-md-x2"
                style={{ 
                    width: '100%', 
                    fontSize: mobHide ? '1.4rem' : 'inherit', // Apply font size only if mobHide is true
                }}
            >
                <span 
                    className="select-icon top-xl-x1" 
                    style={{zIndex: '9'}}
                >
                    <i className="fa fa-caret-down"></i>
                </span>
                <select
                    onChange={handleOrderChange}
                    value={currentOrderID}
                    tw="h-full w-full p-2 border bg-white text-gray-500 focus:ring-brand rounded-md"
                    className="order-id-text"
                    style={{ 
                        fontWeight: '600',
                        backgroundColor: 'white',
                        borderColor: '#999',
                        borderRadius: '5px',
                    }}
                >
                    {ordersList.map((orderItem) => {
                      const displayId = getOrderSelectLabel(orderItem)
                      return (
                    <option key={orderItem.id} value={orderItem.source_id}>
                        {isTiktok ? `#${displayId}` : `Order #${displayId}`}
                    </option>
                      )
                    })}
                </select>
            </div>
        )}
    </div>
  );
};

export default OrderSelect;
